import { QUICK_APPLICATION_FORM_FIELDS, QUICK_APPLICATION_FORM_FIELDS_NAMES } from './quick-application-form';
import { ISelectorData } from '../../../components/application/NewApplication';
import { TFunction } from 'react-i18next';
import { IFormInputProps } from '../../../components/merchants/FormInput';
import { InputType } from '../../../components/form/form-input-constants';

interface IAccountInformationInputsProps {
  t: TFunction;
  partnerList?: ISelectorData[];
  integrationPartnerList?: ISelectorData[];
  integrationTierList?: ISelectorData[];
  accountListSelector?: ISelectorData[];
  salesAgencyListSelector?: ISelectorData[];
  accountManagerList?: ISelectorData[];
  applicationId: string;
  crmId?: string;
}
export const ACCOUNT_INFO_ADMIN_INPUTS = ({
  t,
  partnerList,
  integrationPartnerList,
  integrationTierList,
  accountManagerList,
  salesAgencyListSelector,
  applicationId,
  crmId,
}: IAccountInformationInputsProps): IFormInputProps[] => [
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.FIRST_NAME)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.FIRST_NAME),
  //   inputType: InputType.Text,
  //   required: true,
  //   autoComplete: 'off'
  // },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.LAST_NAME,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.LAST_NAME,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.LAST_NAME)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.LAST_NAME),
  //   inputType: InputType.Text,
  //   required: true,
  //   autoComplete: 'off'
  // },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.EMAIL,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.EMAIL,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.EMAIL)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.EMAIL),
  //   inputType: InputType.Text,
  //   required: true,
  //   disabled: !!applicationId,
  //   readOnly: !!applicationId,
  //   additionalClasses: applicationId && 'disabled',
  //   autoComplete: 'off'
  // },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.PHONE,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.PHONE,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.PHONE)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.PHONE),
  //   inputType: InputType.Phone,
  //   defaultCountry: 'US',
  //   required: true,
  //   autoComplete: 'off'
  // },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.ACCOUNT_MANAGER)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.ACCOUNT_MANAGER),
    inputType: InputType.Select,
    data: accountManagerList,
    // disabled: data?.accountId,
    // required: true,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.PARTNER,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.PARTNER,
    placeholder: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.PARTNER),
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.PARTNER),
    inputType: InputType.Select,
    data: partnerList,
    cleanable: false,
    required: true,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER,
    placeholder: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    inputType: InputType.Select,
    data: integrationPartnerList,
    cleanable: false,
    // required: true,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.SALES_AGENCY)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.SALES_AGENCY),
    inputType: InputType.Select,
    data: salesAgencyListSelector,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER,
    placeholder: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.INTEGRATION_TIER),
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.INTEGRATION_TIER),
    inputType: InputType.Select,
    data: integrationTierList,
    cleanable: false,
    searchable: false,
    required: true,
    autoComplete: 'off'
  },{
    key: QUICK_APPLICATION_FORM_FIELDS.CRM_ID,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.CRM_ID,
    placeholder: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.CRM_ID),
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.CRM_ID),
    inputType: InputType.Text,
    cleanable: false,
    searchable: false,
    required: false,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER,
    placeholder: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.EXTERNAL_MERCHANT_IDENTIFIER),
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.EXTERNAL_MERCHANT_IDENTIFIER),
    inputType: InputType.Text,
    cleanable: false,
    searchable: false,
    required: false,
    autoComplete: 'off'
  },
];

export const ACCOUNT_INFO_PARTNER_INPUTS = ({
  t,
  integrationPartnerList,
  integrationTierList,
  // accountManagerList,
  salesAgencyListSelector,
  applicationId
}: IAccountInformationInputsProps): IFormInputProps[] => [
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.FIRST_NAME)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.FIRST_NAME),
  //   inputType: InputType.Text,
  //   required: true,
  //   autoComplete: 'off'
  // },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.LAST_NAME,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.LAST_NAME,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.LAST_NAME)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.LAST_NAME),
  //   inputType: InputType.Text,
  //   required: true,
  //   autoComplete: 'off'
  // },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.EMAIL,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.EMAIL,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.EMAIL)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.EMAIL),
  //   inputType: InputType.Text,
  //   required: true,
  //   disabled: !!applicationId,
  //   readOnly: !!applicationId,
  //   additionalClasses: applicationId && 'disabled',
  //   autoComplete: 'off'
  // },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.PHONE,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.PHONE,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.PHONE)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.PHONE),
  //   inputType: InputType.Phone,
  //   defaultCountry: 'US',
  //   required: true,
  //   autoComplete: 'off'
  // },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.ACCOUNT_MANAGER)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.ACCOUNT_MANAGER),
  //   inputType: InputType.Select,
  //   data: accountManagerList,
  //   // disabled: data?.accountId,
  //   required: true,
  // },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER,
    placeholder: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.INTEGRATION_PARTNER),
    inputType: InputType.Select,
    data: integrationPartnerList,
    cleanable: false,
    // required: true,
    autoComplete: 'off'
  },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.SALES_AGENCY)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.SALES_AGENCY),
  //   inputType: InputType.Select,
  //   data: salesAgencyListSelector,
  // },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER,
    placeholder: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.INTEGRATION_TIER),
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.INTEGRATION_TIER),
    inputType: InputType.Select,
    data: integrationTierList,
    cleanable: false,
    searchable: false,
    required: true,
    autoComplete: 'off'
  },
];

export const ACCOUNT_INFO_INTEGRATION_PARTNER_INPUTS = ({
    t,
    integrationTierList,
    accountManagerList,
    salesAgencyListSelector,
    applicationId
  }: IAccountInformationInputsProps): IFormInputProps[] => [
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.FIRST_NAME)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.FIRST_NAME),
  //   inputType: InputType.Text,
  //   required: true,
  //   autoComplete: 'off'
  // },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.LAST_NAME,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.LAST_NAME,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.LAST_NAME)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.LAST_NAME),
  //   inputType: InputType.Text,
  //   required: true,
  //   autoComplete: 'off'
  // },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.EMAIL,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.EMAIL,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.EMAIL)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.EMAIL),
  //   inputType: InputType.Text,
  //   required: true,
  //   disabled: !!applicationId,
  //   readOnly: !!applicationId,
  //   additionalClasses: applicationId && 'disabled',
  //   autoComplete: 'off'
  // },
  // {
  //   key: QUICK_APPLICATION_FORM_FIELDS.PHONE,
  //   fieldName: QUICK_APPLICATION_FORM_FIELDS.PHONE,
  //   placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.PHONE)}`,
  //   label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.PHONE),
  //   inputType: InputType.Phone,
  //   defaultCountry: 'US',
  //   required: true,
  //   autoComplete: 'off'
  // },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.ACCOUNT_MANAGER)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.ACCOUNT_MANAGER),
    inputType: InputType.Select,
    data: accountManagerList,
    // disabled: data?.accountId,
    // required: true,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.SALES_AGENCY)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.SALES_AGENCY),
    inputType: InputType.Select,
    data: salesAgencyListSelector,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER,
    placeholder: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.INTEGRATION_TIER),
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.INTEGRATION_TIER),
    inputType: InputType.Select,
    data: integrationTierList,
    cleanable: false,
    searchable: false,
    required: true,
    autoComplete: 'off'
  },
];

export const COMPANY_INFO_INPUTS_FIRST_ROW = ({ t, applicationId }): IFormInputProps[] => [
  {
    key: QUICK_APPLICATION_FORM_FIELDS.COMPANY_NAME,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.COMPANY_NAME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.COMPANY_NAME)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.COMPANY_NAME),
    inputType: InputType.Text,
    required: true,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.DBA,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.DBA,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.DBA)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.DBA),
    inputType: InputType.Text,
    required: true,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.ANNUAL_SALES_VOLUME,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.ANNUAL_SALES_VOLUME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.ANNUAL_SALES_VOLUME)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.ANNUAL_SALES_VOLUME),
    inputType: InputType.Number,
    required: true,
    autoComplete: 'off',
    prefix: '$',
    // suffix: 'USD',
    useNumberFormatter: true,
    shouldFormat: true,
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.DECLINE_RATE,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.DECLINE_RATE,
    placeholder: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.DECLINE_RATE),
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.DECLINE_RATE),
    inputType: InputType.Number,
    required: false,
    autoComplete: 'off',
    suffix: '%',
    min: 0,
    max: 100
  },
];

export const COMPANY_INFO_INPUTS_SECOND_ROW = ({ t, applicationId }): IFormInputProps[] => [
  {
    key: QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.FIRST_NAME)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.FIRST_NAME),
    inputType: InputType.Text,
    required: true,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.LAST_NAME,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.LAST_NAME,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.LAST_NAME)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.LAST_NAME),
    inputType: InputType.Text,
    required: true,
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.EMAIL,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.EMAIL,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.EMAIL)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.EMAIL),
    inputType: InputType.Text,
    required: true,
    disabled: !!applicationId,
    readOnly: !!applicationId,
    additionalClasses: applicationId && 'disabled',
    autoComplete: 'off'
  },
  {
    key: QUICK_APPLICATION_FORM_FIELDS.PHONE,
    fieldName: QUICK_APPLICATION_FORM_FIELDS.PHONE,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(QUICK_APPLICATION_FORM_FIELDS_NAMES.PHONE)}`,
    label: t(QUICK_APPLICATION_FORM_FIELDS_NAMES.PHONE),
    inputType: InputType.Phone,
    defaultCountry: 'US',
    required: true,
    autoComplete: 'off'
  },
];
